import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Menu extends Component {
	render() {
		return (
		<div className="Menu">
			<a href="/deuil/"><div className="MenuItem"><FontAwesomeIcon icon="map"/> Carte</div></a>
			<a href="/deuil/personnages"><div className="MenuItem"><FontAwesomeIcon icon="users"/> Personnages</div></a>
			<a href="/deuil/boite"><div className="MenuItem"><FontAwesomeIcon icon="box-open"/> Boite à Brol</div></a>		
			<a href="/deuil/rapports"><div className="MenuItem"><FontAwesomeIcon icon="file"/> Rapports</div></a>
			<a href="/deuil/bestiaire"><div className="MenuItem"><FontAwesomeIcon icon="paw"/> Bestiaire</div></a>
			<a href="/deuil/rumeurs"><div className="MenuItem"><FontAwesomeIcon icon="question"/> Rumeurs</div></a>			
			<a href="https://discord.gg/fqCGzWm" target="_blank"><div className="MenuItem"><FontAwesomeIcon icon="comments"/> Discord</div></a>
		</div>
		);
	}
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js